var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "32px",
    viewBox: "0 0 100 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Member_Q2_D",
    transform: "translate(-723.000000, -119.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(618.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.443661,0 L203.884912,0 C204.437197,-7.9498914e-15 204.884912,0.44771525 204.884912,1 L204.884912,31 C204.884912,31.5522847 204.437197,32 203.884912,32 L106.443661,32 C105.891376,32 105.443661,31.5522847 105.443661,31 C105.443661,30.7318243 105.551375,30.4748865 105.742616,30.2868832 L119.550114,16.7131168 C119.943957,16.3259402 119.949362,15.6927983 119.562185,15.2989548 C119.558196,15.2948966 119.554172,15.2908726 119.550114,15.2868832 L105.742616,1.7131168 C105.348772,1.32594021 105.343367,0.692798299 105.730544,0.298954763 C105.918547,0.107714194 106.175485,2.71307674e-16 106.443661,0 Z",
    id: "Rectangle-Copy-10"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightD);
export default __webpack_public_path__ + "static/media/rightD.5653958ffa0285ced6699900796cb972.svg";
export { ForwardRef as ReactComponent };